import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { CircularProgress } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { StyledContainer, StyledLoadMoreContainer } from '../index.css'

const StyledCircularProgress = styled(CircularProgress)`
  position: absolute;
`

const LoadingIcon = () => {
  const theme = useDisplayTheme() as Theme

  return (
    <StyledContainer mode={theme}>
      <StyledLoadMoreContainer>
        <StyledCircularProgress size={16} />
      </StyledLoadMoreContainer>
    </StyledContainer>
  )
}

export default LoadingIcon
